import React from "react";
import { Box } from "@material-ui/core";

import { getLocaleValue } from "../../../helpers/get-locale-value";

import NewsCategoryListItemViewDesktop from "./news-category-list-item-view-desktop";

const NewsCategoryListViewDesktop = ({
  locale,
  data,
  location,
  currentNewsCategory,
}) => {
  return (
    <Box>
      {data?.map((n, i) =>
        n.name != "news-category-recycled" ? (
          <NewsCategoryListItemViewDesktop
            locale={locale}
            key={i}
            data={n}
            location={location}
            currentNewsCategory={currentNewsCategory}
          />
        ) : (
          ""
        )
      )}
    </Box>
  );
};

export default NewsCategoryListViewDesktop;
